import type { ScheduleStopValue } from "@RequestFormV2/defaults/scheduleDefaults";
import { StopAddressType } from "types/MultiStop";

function stopHasAddress(stop: ScheduleStopValue): boolean {
  if (stop.stop_address_type === StopAddressType.AIRPORT) {
    return Boolean(stop.stop_airport_code);
  }
  if (stop.stop_address_type === StopAddressType.SEAPORT) {
    return Boolean(stop.stop_seaport_code);
  }
  return Boolean(stop.address_id || stop.address_name || stop.street_address);
}

export function hasScheduleAddressesFilled(stops: ScheduleStopValue[] | undefined): boolean {
  if (!stops || stops.length === 0) return false;
  return stops.every(stopHasAddress);
}
